module.exports = __webpack_public_path__ + "img/Group.465c5ddd.png";